/**
 * WebView 内常见：viewport 未暴露 safe-area，env(safe-area-inset-top) 恒为 0。
 * 优先使用 App 通过 URL 传入的 safeAreaTop（见 葡萄酒APP webview 页 onLoad），
 * 再尝试 CSS env 探测；仍无时再按平台保底（灵动岛机型约需 59px，原先 47 不够）。
 */

function finitePx(v) {
	const n = parseFloat(String(v || ''))
	return Number.isFinite(n) && n >= 0 ? n : 0
}

function getInsetFromUrl() {
	let top = 0
	try {
		const sp = new URLSearchParams(window.location.search || '')
		const a = finitePx(sp.get('safeAreaTop') || sp.get('statusBarHeight'))
		if (a > 0) top = Math.max(top, a)

		const hash = window.location.hash || ''
		const qi = hash.indexOf('?')
		if (qi !== -1) {
			const hp = new URLSearchParams(hash.slice(qi + 1))
			const b = finitePx(hp.get('safeAreaTop') || hp.get('statusBarHeight'))
			if (b > 0) top = Math.max(top, b)
		}
	} catch (e) {
		/* ignore */
	}
	return top
}

function probeEnvInsetTop() {
	if (typeof document === 'undefined' || !document.body) return 0
	try {
		const probe = document.createElement('div')
		probe.style.cssText =
			'position:fixed;left:0;top:0;width:0;height:0;visibility:hidden;pointer-events:none;' +
			'padding-top:constant(safe-area-inset-top);padding-top:env(safe-area-inset-top,0px);'
		document.body.appendChild(probe)
		const v = parseFloat(window.getComputedStyle(probe).paddingTop) || 0
		document.body.removeChild(probe)
		return v
	} catch (e) {
		return 0
	}
}

export function syncSafeAreaInsetTop() {
	if (typeof document === 'undefined') return
	const root = document.documentElement

	const urlTop = getInsetFromUrl()
	let envTop = probeEnvInsetTop()

	const ua = navigator.userAgent || ''
	const isIOS = /iPhone|iPad|iPod/i.test(ua)
	const isIPhone = /iPhone/i.test(ua) && !/iPod/i.test(ua)
	const isAndroid = /Android/i.test(ua)

	let fallback = 0
	// 仅在「页面完全拿不到安全区」时用保底，避免在无刘海 iPhone 上误加 59px
	const missing = urlTop < 1 && envTop < 1
	if (missing) {
		if (isIOS) {
			fallback = isIPhone ? 59 : 44
		} else if (isAndroid) {
			fallback = 32
		}
	}

	let top = Math.max(urlTop, envTop, fallback)
	if (!Number.isFinite(top) || top < 0) top = 0
	/* 防止异常 URL / 系统返回值过大导致顶栏被挤出视口或 calc 异常 */
	top = Math.min(top, 120)

	root.style.setProperty('--app-safe-area-top', `${top}px`)
}

export function watchSafeAreaInsetTop() {
	const handler = () => syncSafeAreaInsetTop()
	window.addEventListener('orientationchange', handler)
	window.addEventListener('resize', handler)
	window.addEventListener('hashchange', handler)
	if (window.visualViewport) {
		window.visualViewport.addEventListener('resize', handler)
	}
	return () => {
		window.removeEventListener('orientationchange', handler)
		window.removeEventListener('resize', handler)
		window.removeEventListener('hashchange', handler)
		if (window.visualViewport) {
			window.visualViewport.removeEventListener('resize', handler)
		}
	}
}
